// REDUX
import { selectIsCheckingAccountStatus, selectCompletedOnboard } from 'redux/onBoarding/selector';

import { useAppSelector } from './redux';

export interface RequiredOnboardingState {
  // checkAccountStatus (/profile/migration-status) hasn't resolved yet - completedOnboard is not
  // trustworthy, so the caller must show a spinner rather than guess
  isChecking: boolean;
  // Onboarding is confirmed incomplete - the caller must bounce the user to Home (Welcome), which
  // is where the wizard restarts from
  shouldRedirectHome: boolean;
}

// Guards every page that is only meaningful once the logged-in user has finished onboarding. Unlike
// useOnboardingSessionGuard (which protects the steps *inside* the wizard), this protects everything
// *outside* it - onboarding URLs and FAQ are exempted by simply not being wrapped, see routes/index.
//
// The isChecking phase matters most for a directly-hit URL: App.container only dispatches
// checkAccountStatus once generateAssociation resolves, so completedOnboard sits at its initial
// `false` for the first few hundred ms of every app load. Without this flag a deep link would render
// its page (and fire its own data calls) and then be yanked to Home, or - worse - be bounced to Home
// even though onboarding was actually complete.
export const useRequiredOnboarding = (): RequiredOnboardingState => {
  const isChecking = useAppSelector(selectIsCheckingAccountStatus);
  const completedOnboard = useAppSelector(selectCompletedOnboard);

  return {
    isChecking,
    shouldRedirectHome: !isChecking && !completedOnboard
  };
};
